<form [formGroup]="profileForm" class="catalog-masterdata no-field-space">

  <sc-flex >
    <app-dictionary-entry-label  [model]="catalog?.name">
    </app-dictionary-entry-label>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-icon-button (click)="changeCatalogTitle()">
          <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button  [disabled]="!downloadEnabled" (click)="exportCatalogArticles()">
        <mat-icon><sc-icon iconClass="fa-download"></sc-icon></mat-icon>
        {{ 'download articles' | translate: ['erp.ui.catalog.action.download-articles', translationService.language]}}
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="importCostsPrices()">
        <mat-icon><sc-icon iconClass="fa-upload"></sc-icon></mat-icon>
        {{ 'import costsprices' | translate: ['erp.ui.catalog.action.import-costsprices', translationService.language]}}
      </button>
  </sc-flex>
</form>
